export default {
  searchTextHladanyTermin: '',
  searchTextDoktrinalnyZdroj: '',
  searchTextLegalnyZdroj: '',
  pouzitiePredpisList: [],
  tezaurus: null,
};
